module.exports = __webpack_public_path__ + "img/prev.561ec16a.svg";